export default class Page {
    hasFocus() {
        return document.hasFocus();
    }
}
